<script setup lang="ts">
defineProps<{ status: string }>();

const labels: Record<string, string> = {
  created: "已建立",
  payment_requested: "等待付款",
  confirming: "確認款項",
  paid: "已付款",
  payment_failed: "付款失敗",
  cancelled: "已取消",
  refunded: "已退款",
  queued: "等待產生",
  generating: "產生中",
  ready: "可下載",
  failed: "產生失敗",
  accepted: "已受理",
  enqueued: "已排程",
  delivery_pending: "等待補送"
};
</script>

<template>
  <span class="status-badge" :data-status="status">
    <i aria-hidden="true"></i>{{ labels[status] || status }}
  </span>
</template>
